import React, { useState, useEffect } from 'react';
import { Dropdown, Slider } from 'tea-component';
import '@/pages/intelligence/assets/scss/TopCharts/components/HeatRangeSelect.scss';
import { useIntl } from 'umi'

const marks = [{ value: 0 }, { value: 20 }, { value: 50 }, { value: 100 }];

export default function HeatRangeSelect(props: any) {
  const { value: defaultValue, onConfirm } = props;

  const [sliderValue, setSliderValue] = useState(defaultValue || []);

  const { formatMessage } = useIntl()

  useEffect(() => {
    setSliderValue(defaultValue);
  }, [defaultValue]);

  const onChangeSlider = (value: number[]) => {
    setSliderValue(value);
    if (onConfirm instanceof Function) {
      onConfirm(value);
    }
  };

  return (
    <Dropdown
      className="heat-range-select"
      button={
        <div className="range-flex">
          <span className="range-flex-text">{formatMessage({ id: 'dbi_heat_range'})}</span>
          {sliderValue[0]} - {sliderValue[1]}
        </div>
      }
      appearance="button"
      boxClassName="heat-range-customize"
      clickClose={false}
    >
      {(close) => (
        <Slider
          className="customize-slider"
          rangeMode
          min={0}
          max={100}
          marks={marks}
          defaultValue={sliderValue}
          onChange={onChangeSlider}
        />
      )}
    </Dropdown>
  );
}
